import { Component, OnInit } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';

@Component({
  selector: 'app-secondnavbar',
  templateUrl: './secondnavbar.component.html',
  styleUrls: ['./secondnavbar.component.scss']
})
export class SecondnavbarComponent implements OnInit {
  dataId : any ;
  id: any;
  data : [
    {
      position : '5',
      url: 'editar-datos-norm35-step5',
    }
  ]

  constructor(private activated: ActivatedRoute) {
    console.log(this.activated.snapshot.paramMap.get('dataId'));
  }

  ngOnInit() {
    this.activated.data.subscribe  (params=>{this.dataId = params});
    console.log(this.dataId);
    let id = +this.activated.snapshot.paramMap.get('dataId');
  }

}
